/**
 * @generated SignedSource<<8a38d93c42c5f07a3f4c0f095965be7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIPerWeekdayAnalytics$data = {
  readonly icon: RoutineIcon | null;
  readonly id: string;
  readonly scheduledDays: ReadonlyArray<number>;
  readonly title: string;
  readonly unit: NumberTaskUnit;
  readonly weekdaySectionAggregates: ReadonlyArray<{
    readonly results: ReadonlyArray<{
      readonly value: number;
      readonly weekday: number;
    }>;
    readonly section: {
      readonly assignedTeam: {
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly title: string | null;
    };
  } | null>;
  readonly " $fragmentType": "KPIPerWeekdayAnalytics";
};
export type KPIPerWeekdayAnalytics$key = {
  readonly " $data"?: KPIPerWeekdayAnalytics$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIPerWeekdayAnalytics">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIPerWeekdayAnalytics",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduledDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KPISectionWeekdayAggregate",
      "kind": "LinkedField",
      "name": "weekdaySectionAggregates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KPIWeekdayAggregateResult",
          "kind": "LinkedField",
          "name": "results",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weekday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KPI",
  "abstractKey": null
};
})();

(node as any).hash = "b542273ef327695c0a4162b118eb1c12";

export default node;
